import React from 'react';
import { Modal } from 'react-bootstrap';
import ActionButtons from '../../crm/shared/field_inputs/shared/ActionButtons';

export default function EditLectureAttendancesModal({open, onClose, title, children, onSave, isSaving}) {
    return (
        <Modal
            show={open}
            onHide={onClose}
            centered
        >
            <div className='d-flex justify-content-between align-items-center padding-top-20px padding-left-20px padding-right-20px'>
                <h4 className='margin-none'>{title}</h4>
                <button type='button' className='btn btn-secondary crm-modal-btn ' onClick={onClose}>
                    &times;
                </button>
            </div>
            <Modal.Body>
                {children}
            </Modal.Body>
            <Modal.Footer>
                <ActionButtons {...{onCancel: onClose, onSave, isSaving}} />
            </Modal.Footer>
        </Modal>
    )
}